import Icon from "components/Icon/Icon";
import LinkButton from "../../LinkButton";
import PreLoader from "components/PreLoader/PreLoader";
import styled from "styled-components";

export const Hint = styled.p`
  margin: 0 0 15px;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.textSecondary};
`;

interface DropZoneProps {
  $isDragging: boolean;
}

export const DropZone = styled.div<DropZoneProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 15px;
  margin-bottom: 15px;
  text-align: center;
  border: 1px dashed
    ${({ theme, $isDragging }) =>
      $isDragging ? theme.primary : theme.formBorder};
  border-radius: 2px;
  background-color: ${({ theme, $isDragging }) =>
    $isDragging ? theme.primary10 : theme.dropdownBg};
  transition:
    border-color 0.15s,
    background-color 0.15s;
`;

export const DropZoneIcon = styled(Icon)`
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.primary};
`;

export const DropZoneText = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.textMain};
`;

export const DropZoneHint = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const FileName = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.textMain};
  word-break: break-all;
`;

export const TextButton = styled(LinkButton).attrs({ tone: "danger" })``;

export const ManualRow = styled.div`
  display: flex;
  justify-content: center;
`;

export const StatusBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 30px 0 10px;
`;

export const SpinnerHolder = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 15px;
`;

export const Spinner = styled(PreLoader)``;

export const StatusText = styled.p`
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.textMain};
`;

export const Detail = styled.p`
  margin: 0 0 15px;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.textSecondary};
  word-break: break-word;
`;

export const DetailsList = styled.ul`
  margin: 0 0 15px;
  padding-left: 20px;
  text-align: left;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.red};
`;

// The list's AddressesWrapper is height: 100%; the review card must not be.
export const CardWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.divider};
`;

export const ReviewMeta = styled.p`
  margin: 10px 0 0;
  font-size: 13px;
  color: ${({ theme }) => theme.textMain};
`;
